import { render, staticRenderFns } from "./BaseModalReorder.vue?vue&type=template&id=50cd8041&scoped=true&"
import script from "./BaseModalReorder.vue?vue&type=script&lang=js&"
export * from "./BaseModalReorder.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalReorder.vue?vue&type=style&index=0&id=50cd8041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd8041",
  null
  
)

export default component.exports